/**
 * This code was AUTOGENERATED using the Codama library.
 * Please DO NOT EDIT THIS FILE, instead use visitors
 * to add features, then rerun Codama to update it.
 *
 * @see https://github.com/codama-idl/codama
 */

import {
  addDecoderSizePrefix,
  addEncoderSizePrefix,
  combineCodec,
  getAddressDecoder,
  getAddressEncoder,
  getArrayDecoder,
  getArrayEncoder,
  getI64Decoder,
  getI64Encoder,
  getStructDecoder,
  getStructEncoder,
  getU32Decoder,
  getU32Encoder,
  getU64Decoder,
  getU64Encoder,
  getUtf8Decoder,
  getUtf8Encoder,
  type Address,
  type Codec,
  type Decoder,
  type Encoder,
} from "@solana/kit";

export type AgentVerificationData = {
  agentPubkey: Address;
  serviceEndpoint: string;
  supportedCapabilities: Array<bigint>;
  verifiedAt: bigint;
};

export type AgentVerificationDataArgs = {
  agentPubkey: Address;
  serviceEndpoint: string;
  supportedCapabilities: Array<number | bigint>;
  verifiedAt: number | bigint;
};

export function getAgentVerificationDataEncoder(): Encoder<AgentVerificationDataArgs> {
  return getStructEncoder([
    ["agentPubkey", getAddressEncoder()],
    [
      "serviceEndpoint",
      addEncoderSizePrefix(getUtf8Encoder(), getU32Encoder()),
    ],
    ["supportedCapabilities", getArrayEncoder(getU64Encoder())],
    ["verifiedAt", getI64Encoder()],
  ]);
}

export function getAgentVerificationDataDecoder(): Decoder<AgentVerificationData> {
  return getStructDecoder([
    ["agentPubkey", getAddressDecoder()],
    [
      "serviceEndpoint",
      addDecoderSizePrefix(getUtf8Decoder(), getU32Decoder()),
    ],
    ["supportedCapabilities", getArrayDecoder(getU64Decoder())],
    ["verifiedAt", getI64Decoder()],
  ]);
}

export function getAgentVerificationDataCodec(): Codec<
  AgentVerificationDataArgs,
  AgentVerificationData
> {
  return combineCodec(
    getAgentVerificationDataEncoder(),
    getAgentVerificationDataDecoder(),
  );
}
